<script setup>

import TaskList from '@/components/list/TaskList.vue'

</script>

<template>

<div class="col-span-2 flex flex-col border border-slate-200 p-4">
    <h3 class="m-auto text-2xl p-2 flex justify-center items-center">
        Tâches
    </h3>
    <div class="mt-2 line">
        <TaskList :limit="3" />

        <div class="mt-2 mb-8">
            <router-link :to="{name: 'task'}" title="Tâches" class="hover:underline">
                Voir toutes les tâches
            </router-link>
        </div>
    </div>
</div>

</template>
